import React from 'react';
import PropTypes from 'prop-types';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';
import {decimaltoHex, RGBFormatFromDecimal} from '../../../../utilities/common';
import { JRE_MAX_FONT_SIZE } from '../../../../config';
import {isEmpty} from '../../../../utilities/validation';
import {connect} from 'react-redux';

const getDataFromNode = function(node) {
    const keys = ['title', 'id', 'x', 'y', 'zIndexOverride', 'width', 'height', 'selectable', 'visible', 'text_align',
        'vertical_align', 'fontsize', 'fontcolor', 'fontstyle', 'bgcolor', 'bgalpha', 'line_height', 'auto_size'];
    const props = filterNodeProperties(node, keys, { val: node.val });
    props.visible = props.visible === '1';
    return props;
};

class TextNode extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node),
            textVisibilityEvent: {},
            zIndex: props.zIndex
        };

        this.timesUpEvent = this.mtDisplayText.bind(this);
        this.mtInvisibleEvent = this.mtHideText.bind(this);
        this.hideTextEvent = this.hideText.bind(this);
        this.showTextEvent = this.showText.bind(this);
    }

    componentDidMount() {
        document.addEventListener('jre-text-times-up', this.timesUpEvent);
        document.addEventListener('jre-mt-invisible', this.mtInvisibleEvent);
        document.addEventListener('jre-text-show', this.showTextEvent);
        document.addEventListener('jre-text-hide', this.hideTextEvent);
        // while(val.indexOf('[', 0) > 0) {
        //     // if(val.indexOf('[', 0) > 0) {
        //     const key = val.substring(val.indexOf('[', 0)+1, val.indexOf(']', 0));
        //     let value = '';
        //     if(!isEmpty(answers[key])){
        //         value = answers[key];
        //     }
        //     val = val.replace(key, value).replace('[', '').replace(']', '');
        // }
        //
        // while(val.indexOf('{{', 0) > 0) {
        //     // if(val.indexOf('[', 0) > 0) {
        //     const key = val.substring(val.indexOf('{{', 0)+1, val.indexOf('}}', 0));
        //     alert (key);
        //     // let value = '';
        //     // if(!isEmpty(answers[key])){
        //     //     value = answers[key];
        //     // }
        //     // val = val.replace(key, value).replace('[', '').replace(']', '');
        // }
        // this.setState({val:val});
    }

    componentWillUnmount() {
        document.removeEventListener('jre-text-times-up', this.timesUpEvent);
        document.removeEventListener('jre-mt-invisible', this.mtInvisibleEvent);
    }

    mtHideText() {
        /* Events with the target name "MT" reference this text. These text nodes may exist at the top level, under the
        page element, in the XML. */
        if (this.state.id.toLocaleLowerCase() === 'mt') {
            this.setState({
                visible: false
            });
        }
    }

    mtDisplayText(e) {
        const {textVisibilityEvent = {}} = this.state;
        const param = e.detail.childWithAttribute('name', 'param') || '';
        const value = e.detail.childWithAttribute('name', 'value') || '';

        if (param && param.attr.value === 'visible' && value) {
            this.setState({
                textVisibilityEvent: {
                    ...textVisibilityEvent,
                    [e.detail.attr.target]: (value.attr.value === 'true')
                }
            });
        }
    }

    showText(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.setState({visible: true});
        }
    }

    hideText(e) {
        if ((typeof this.props.node.attr.id !== undefined) && (typeof e.detail.target !== undefined)
            && this.props.node.attr.id.toLowerCase() === e.detail.target.toLowerCase()) {
            this.setState({visible: false});
        }
    }

    render() {
        const {id, x = 0, y = 0, width = 0, height = 0, zIndexOverride, text_align = 'left', visible = true,
            fontstyle = 'normal', textVisibilityEvent = {}, zIndex = null, val = '', bgcolor, bgalpha = '1', title = '',
            line_height = '', auto_size = 1,
        } = this.state;

        let fontcolor = 'inherit';
        if(!isEmpty(this.state.fontcolor)) {
            fontcolor = `#${decimaltoHex(this.state.fontcolor)}`;
        }

        /* If XML does not have font-size use 24px as specified in JRE_MAX_FONT_SIZE, else use the specified
         font-size*/
        let fontsize = parseInt(this.state.fontsize) ? `${parseInt(this.state.fontsize)}px`: `${JRE_MAX_FONT_SIZE}px`;

        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            textAlign: text_align,
            width: `${width}px`,
            /* See Plastics & Polymers - 3.1.0, section 202, the text_node has a height of 690px, just using "auto"
            will not work. */
            height: height ? `${height}px` : 'auto',
            maxHeight: `${height}px`,
            wordBreak: 'break-word',
            // If text visibility was set by an event then use it, otherwise, use the default visibility.
            display: (textVisibilityEvent[id] || visible) ? 'block' : 'none',
            color: fontcolor,
            // Plain/normal and bold appear to be the only options.
            fontWeight: (fontstyle === 'bold') ? fontstyle : 'normal',
            fontSize: fontsize,
            backgroundColor: !isEmpty(bgcolor) ? RGBFormatFromDecimal(bgcolor, bgalpha) : 'transparent',
        };


        if (zIndex !== null) {
            divStyle.zIndex = zIndex;
        }
        // XML files normally do not include z-index.
        // When we use our XML transformer (xml-transform.js) to override the css z-index, zIndexOverride is true.
        if (zIndexOverride) {
            divStyle.zIndex = zIndexOverride;
        }

        /* See Robo-Review slide/section on Energy, Power & Mechanics module. The "Robo-Review" link should clickable
         and above the other text node. Currently, other jre-text-nodes have a z-index of 1. */
        if (title && title.toLowerCase().includes('launch')) { // Match "launch' actions such as "Launch Robo-Review".
            divStyle.zIndex = 2;
        }

        if(parseInt(auto_size) === 0) {
            /*
            Joey Himes added a comment - 02/May/19 4:03 PM Barney Lukaroski, I believe I have identified the setting
             in the XML file that should generate a scroll bar for text_nodes. Based on what I'm seeing each of
              these includes a parameter that is auto_size="0". Most are set to "1" and should not have a scroll
               bar, but every time I have seen a scroll bar needed it has included the SML parameter of auto_size="0"
            */
            divStyle.overflowY = 'auto';
        }

        if(line_height){
            divStyle.lineHeight = `${line_height}px`;
        }

        /* Note: we have issues in some cases where the HTML of a text node is not formatted correctly. For example,
         * there are missing <li> tags and there are \r characters that could ideally be <br> or <p> tags.
         * We may have to do something like this to take account of the characters.
         * val.split('\r').map(function(item, key) {return (<p key={key}>{item}</p>)}) */
        return (
            <div className="node jre-text-node" style={divStyle} dangerouslySetInnerHTML={{__html:val}} />
        );
    }
}

TextNode.propTypes = {
    node: PropTypes.object.isRequired,
    zIndex: PropTypes.number
};


const mapStateToProps = (state) => {
    return {
        answers: state.answers.list,
    };
};

const TextNodeContainer = connect(
    mapStateToProps,
    null
)(TextNode);

export default TextNodeContainer;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/text-node.js